import * as Yup from "yup";

export const EmployeeSchema = Yup.object({
    first_name: Yup.string().required("Please enter first name"),
    last_name: Yup.string().required("Please enter last name"),
    phone: Yup.string().required("Please enter phone number").matches(/^(\+\d{1,3}[- ]?)?\d{8,16}$/, "Please enter minimum 8 and maximum 16 digit"),
    email: Yup.string().required("Please enter email").email("Please enter a valid email"),
    password: Yup.string().required("Please enter password").matches(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/, 'Password should be a minimum of eight characters in length and must contains at least a letter, number and a special character.'),
});